import type { PreviewUploadsController } from '../../../hooks/useDappFileHandlers';
import * as Form from '../../Form';
import { PreviewUploadsField as SharedPreviewUploadsField } from '../../dapp-form/PreviewUploadsField';

interface PreviewUploadsFieldProps {
  dappPreviews: (File | null)[];
  previewUploads: PreviewUploadsController;
}

export function PreviewUploadsField({
  dappPreviews,
  previewUploads,
}: PreviewUploadsFieldProps) {
  return (
    <SharedPreviewUploadsField
      dappPreviews={dappPreviews}
      previewDimensions={previewUploads.previewDimensions}
      orientation={previewUploads.orientation}
      isOrientationLocked={previewUploads.isOrientationLocked}
      onOrientationChange={previewUploads.setOrientation}
      onFilesSelected={previewUploads.handlePreviewFilesChange}
      renderUploadSlot={(index) => (
        <Form.MediaUploadInput
          name={`dappPreview-${index}`}
          value={dappPreviews[index] ?? null}
          onChange={(file: File | null) =>
            previewUploads.handlePreviewFileChange(index, file)
          }
          placeholderClassName="absolute inset-0"
          buttonType="add"
        />
      )}
    />
  );
}
